/* unplugin-vue-components disabled */import { render } from "./portal-password-notice.vue?vue&type=template&id=ce871724&scoped=true"
import script from "./portal-password-notice.vue?vue&type=script&lang=js"
export * from "./portal-password-notice.vue?vue&type=script&lang=js"

import "./portal-password-notice.vue?vue&type=style&index=0&id=ce871724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce871724"]])

export default __exports__